import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {  RoomTypeApiResponse } from '../../types/api/roomApi';
import {  getRoomTypeDataService } from '../../api/roomApi';
import { RoomState } from '../../types/features/roomSlice';



export const getRoomTypeData = createAsyncThunk<RoomTypeApiResponse>(
    'room/getRoomTypeData',
    async () => {
        const response = await getRoomTypeDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

// export const getRoomData = createAsyncThunk<{ id: string }, RoomApiResponse>(
//     'room/getRoomData',
//     async (id: string) => {
//         const response = await getRoomDataService(id);
//         return response.data; // Assumes response has a 'data' property
//     }
// );

const roomSlice = createSlice({
    name: 'room',
    initialState: {
        roomLoader: false,
        room_types: [],
        // room_data: {},
        status: false,
        msg: ''
    } as RoomState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoomTypeData.pending, (state) => {
                state.roomLoader = true;
            })
            .addCase(getRoomTypeData.fulfilled, (state, action: PayloadAction<RoomTypeApiResponse>) => {
                state.room_types = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.roomLoader = false;
            })
            .addCase(getRoomTypeData.rejected, (state, action) => {
                state.roomLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
        // .addCase(getRoomData.pending, (state) => {
        //     state.roomLoader = true;
        // })
        // .addCase(getRoomData.fulfilled, (state, action: PayloadAction<RoomApiResponse>) => {
        //     state.room_data = action.payload.data;
        //     state.msg = action.payload.message;
        //     state.status = true;
        //     state.roomLoader = false;
        // })
        // .addCase(getRoomData.rejected, (state, action) => {
        //     state.roomLoader = false;
        //     state.status = false;
        //     state.msg = action.error.message;
        // })
    }
});

export default roomSlice.reducer;
